import styled from 'styled-components';
import { media, DeprecatedGrid as Grid } from '@simplywallst/ui-core';

export const Container = styled('header')``;

export const Title = styled('h1')`
  margin: 0 0 ${({ theme }) => theme.x1spacePx}px;
  ${({ theme }) => theme.typography.megaStrong};
`;

export const HeaderWrapper = styled('div')`
  background-color: ${({ theme }) => theme.color.noir};
  border-radius: ${({ theme }) => `${theme.x1spacePx}px`};
  margin-bottom: ${({ theme }) => `${theme.x3spacePx}px`};

  ${media.mdDown`
    border-radius: 0;
  `};
`;

export const TitleContainer = styled('div')`
  > div {
    min-height: ${({ theme }) => theme.x19spacePx}px;
    padding: ${({ theme }) => `${theme.x3spacePx}px ${theme.x4spacePx}px`};
    > div {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }

    ${media.mdDown`
      min-height: ${({ theme }) => theme.x16spacePx}px;
      padding: ${({ theme }) => `${theme.x3spacePx}px ${theme.x2spacePx}px`};
    `}
  }
`;

export const MiscContainer = styled(Grid)`
  ${({ theme }) => theme.typography.tiny};
  grid-auto-flow: column;
  > div {
    display: inline-grid;
    grid-template-columns: auto auto;
    margin-right: ${({ theme }) => theme.x3spacePx}px;
    span {
      text-transform: uppercase;
      color: ${({ theme }) => theme.color.whiteRGBA(0.7)};
      padding-right: ${({ theme }) => theme.x1spacePx / 2}px;
      padding-bottom: ${({ theme }) => theme.x1spacePx / 2}px;
    }
  }
  ${media.mdDown`
    grid-auto-flow: row;
    > div {
      grid-template-columns: 80px 200px;
    }
  `}
`;

export const MarketPerformance = styled('ul')`
  padding: ${({ theme }) => `${theme.x2spacePx}px ${theme.x4spacePx}px`};
  padding-bottom: ${({ theme }) => theme.x1spacePx}px;
  ${media.mdDown`
    padding: ${({ theme }) => theme.x2spacePx}px;
  `}
`;

export const MarketPerformanceValue = styled('li')`
  display: inline-block;
  > span {
    display: block;
    &:first-child {
      ${({ theme }) => theme.typography.tiny};
      color: ${({ theme }) => theme.color.whiteRGBA(0.5)};
    }
    &:last-child {
      ${({ theme }) => theme.typography.xSmall};
      min-width: ${({ theme }) => theme.x10spacePx}px;
      ${media.lgDown`
        min-width: ${({ theme }) => theme.x8spacePx}px;
      `};
    }
  }
`;

export const MarketBrief = styled('p')`
  ${({ theme }) => theme.typography.small};
  margin: 0 ${({ theme }) => theme.x4spacePx}px;
  padding-bottom: ${({ theme }) => theme.x3spacePx}px;
  ${media.mdDown`
    margin: 0 ${({ theme }) => theme.x2spacePx}px;
  `}
`;

export const Navigation = styled('div')`
  display: flex;
  padding-bottom: ${({ theme }) => theme.x1spacePx}px;
  ${media.mdDown`
	  padding: 0;
    margin: ${({ theme }) => theme.x1spacePx}px;
    margin-left: ${({ theme }) => theme.x2spacePx}px;
	`};
`;

export const CrumbsWrapper = styled('div')`
  flex: 1;
  padding-bottom: ${({ theme }) => theme.x1spacePx}px;
  margin-top: ${({ theme }) => -theme.x1spacePx}px;

  a {
    text-decoration: underline;
  }
`;

export const TrendingIndustries = styled(Grid)`
  margin: 0 ${({ theme }) => theme.x4spacePx}px;
  padding-bottom: ${({ theme }) => theme.x2spacePx}px;
  white-space: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  a {
    border-radius: ${({ theme }) => theme.x2spacePx + 2}px;
    border: 1px solid ${({ theme }) => theme.color.whiteRGBA(0.2)};
    color: ${({ theme }) => theme.color.white};
  }
  span {
    ${({ theme }) => theme.typography.xSmall};
    color: ${({ theme }) => theme.color.paperRGBA(0.7)};
    width: ${({ theme }) => theme.x8spacePx}px;
    white-space: normal;
  }
  ${media.mdDown`
    margin: 0 ${({ theme }) => theme.x2spacePx}px;
  `}
`;
